import React from 'react'
import { Alert, Button, CircularProgress } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

type Props = {
  analysisType: string
  onReanalyze: () => void
  isReanalyzing: boolean
}

/**
 * Banner exibido quando segmentos foram editados após a geração das análises,
 * indicando que o resultado pode estar desatualizado em relação ao texto atual.
 */
export default function AnalysisOutdatedBanner({ analysisType, onReanalyze, isReanalyzing }: Props) {
  return (
    <Alert
      severity="warning"
      icon={<WarningAmberIcon fontSize="small" />}
      action={
        <Button
          size="small"
          color="warning"
          variant="outlined"
          onClick={onReanalyze}
          disabled={isReanalyzing}
          startIcon={isReanalyzing ? <CircularProgress size={12} color="inherit" /> : undefined}
          sx={{ whiteSpace: 'nowrap', fontWeight: 600, fontSize: '0.75rem' }}
        >
          {isReanalyzing ? 'Analisando...' : 'Re-analisar'}
        </Button>
      }
      sx={{
        mb: 2,
        fontSize: '0.8rem',
        alignItems: 'center',
        '#monkee-file-transcript-client &': {
          backgroundColor: '#fff8e1 !important',
          color: '#5d4037 !important',
          border: '1px solid #ffe082 !important',
        }
      }}
    >
      Segmentos foram editados após a geração desta análise. Os resultados podem não refletir o texto atual da transcrição.
    </Alert>
  )
}
